"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Icon = exports.GreetingMessageAndContact = exports.ConfirmButton = exports.BannerDialog = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  textAlign: 'center'
}));
const GreetingMessageAndContact = exports.GreetingMessageAndContact = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  width: '100%',
  '&:empty': {
    display: 'none'
  }
}));
const Icon = exports.Icon = (0, _mui.styled)(_icons.Gift)({
  height: 48,
  width: 48
});
const BannerDialog = exports.BannerDialog = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  [`& .${_mui.paperClasses.root}`]: {
    [theme.breakpoints.up('sm')]: {
      width: 390
    }
  }
}));
const ConfirmButton = exports.ConfirmButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  marginTop: theme.spacing(3)
}));